




















import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CartHeader from '../components/cart/CartHeader.vue';
import CartPreview from '../components/cart/CartPreview.vue';
import Slide from '../interfaces/models/Slide';
import { EventBus } from '../event-bus';
import CartActionView from './cart/CartActionView.vue';

const cart = namespace('cart');

@Component({
  components: {
    cartHeader: CartHeader,
    cartPreview: CartPreview,
    cartActionView: CartActionView
  }
})
export default class CartView extends Vue {
  private open: boolean = false;

  @cart.State(s => s.selection) selection!: string[];
  @cart.State(s => s.items) cartItems!: string[];
  @cart.State(s => s.cartMap) cartMap!: { [key: string]: Slide };

  @cart.Mutation('shiftToCart') shift!: () => void;
  @cart.Mutation('remove') removeFromCart!: (id: string) => void;

  get cartClasses() {
    return `cart ${this.open ? 'cart--opened' : 'cart--closed'}`;
  }

  @Watch('cartItems')
  onCartChange(cart: string[]) {
    if (cart.length === 0) {
      this.open = false;
    }
  }

  shiftToCart() {
    this.open = true;
    this.shift();
    EventBus.$emit('shift-to-cart', true);
  }

  async onAction(data: { id?: string; type: 'archive' }) {
    console.log(data);
    try {
      switch (data.type) {
        case 'archive':
          return await Promise.all(
            this.cartItems.map(id => {
              return this.$store.dispatch('slides/archiveActiveSlide', id);
            })
          );
          break;

        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  }

  removeItem(id: string) {
    if (!id) return;

    this.removeFromCart(id);
  }
}
